import CodeModule from './components/CodePage/CodePage';
import CodeErrorPage from './components/ErrorPage/ErrorPage';
import { codeEpics } from './store/code.epics';
import codeReducer from './store/code.reducer';

export { CodeErrorPage, codeEpics, codeReducer };

export default CodeModule;
